import requestAction from '../../utils/requestAction'

export const deleteLinkedVendors = (linkedVendorId: number) =>
  requestAction('LINKED_VENDORS_DELETE')(
    `linkedVendors/${linkedVendorId}`,
    'DELETE')

export const deleteAllLinkedVendors = (personId: number) =>
  requestAction('LINKED_VENDORS_DELETE')(
    `linkedVendors/all/${personId}`,
    'DELETE')
